var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "192",
        viewBox: "0 0 175 192",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c(
        "defs",
        [
          _c(
            "linearGradient",
            {
              attrs: {
                x1: "0%",
                y1: "50%",
                x2: "100%",
                y2: "50%",
                id: "0s2lbhkwua",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#FFF", offset: ".518%" } }),
              _c("stop", {
                attrs: { "stop-color": "#FAFAFA", offset: "31.11%" },
              }),
              _c("stop", {
                attrs: { "stop-color": "#ECECED", offset: "66.36%" },
              }),
              _c("stop", {
                attrs: { "stop-color": "#D8D8D9", offset: "100%" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
        _c("g", { attrs: { "fill-rule": "nonzero" } }, [
          _c("path", {
            attrs: {
              d: "M42 155.5c.2 3.3.1 6.6-1.5 8.4-4.2 4.7-8.2-4.2-9.7-8.6-.1-.3-.1-.5-.2-.8-1.6-4.9-2.3-10.2-4.2-14.9-2.5-6.3-6.7-11.5-10.4-17.1C1.3 100-2.6 69.7 5.7 43.6c1.6-4.9 3.5-9.6 5.5-14.3 1.6-3.9 3.3-7.8 6-10.9 2.7-3.2 5.7-5.6 8.1-9 2.6-3.8 4.4-7.3 9.1-8.2 1.6-.3 3.4-.3 4.8.8 1.8 1.3 2.2 8.2 2.3 13.4l.5 140.1z",
              fill: "#FFF",
            },
          }),
          _c("path", {
            attrs: {
              d: "M42 153.8c.2 3.2.1 6.5-1.5 8.2-4.2 4.6-8-4.2-9.5-8.4-.1-.2-.1-.5-.2-.8-1.5-4.8-2.2-9.9-4-14.5-2.4-6.1-6.6-11.2-10.1-16.7-14.1-21.8-18-51.4-9.8-76.7 1.6-4.8 3.4-9.3 5.4-14 1.6-3.8 3.2-7.5 5.8-10.6 2.7-3 5.5-5.4 7.9-8.8 2.5-3.7 4.3-7.1 8.9-8 1.6-.3 3.3-.3 4.7.8 1.7 1.2 2.1 8 2.3 13l.1 136.5z",
              fill: "#FEFEFE",
            },
          }),
          _c("path", {
            attrs: {
              d: "M42 151.8c.2 3.2.1 6.3-1.4 7.9-4.1 4.5-7.8-4.1-9.1-8.2-.1-.2-.1-.5-.2-.7-1.5-4.7-2.2-9.6-3.9-14.2-2.3-5.9-6.4-10.9-9.8-16.2C3.9 99.3.3 70.3 8.1 45.8c1.5-4.6 3.4-9.1 5.2-13.6 1.5-3.7 3.1-7.4 5.6-10.3 2.6-2.9 5.4-5.3 7.6-8.5 2.4-3.6 4.2-6.9 8.7-7.8 1.6-.3 3.2-.2 4.6.7 1.7 1.2 2.1 7.8 2.2 12.6v132.9z",
              fill: "#FCFCFC",
            },
          }),
          _c("path", {
            attrs: {
              d: "M42 150c.2 3 .1 6.1-1.4 7.7-4 4.3-7.5-3.9-8.9-7.9-.1-.2-.1-.5-.2-.7-1.4-4.6-2.1-9.2-3.8-13.7-2.3-5.9-6.2-10.7-9.5-15.8C4.9 98.9 1.2 70.9 8.9 47c1.5-4.6 3.2-8.9 5-13.2 1.5-3.6 3-7.2 5.5-10s5.2-5.1 7.4-8.2c2.4-3.5 4.1-6.7 8.3-7.5 1.5-.3 3.1-.2 4.3.7 1.6 1.2 1.9 7.5 2.2 12.4L42 150z",
              fill: "#FBFBFB",
            },
          }),
          _c("path", {
            attrs: {
              d: "M42 148.1c.2 2.8.1 5.9-1.3 7.5-3.8 4.2-7.3-3.9-8.5-7.7-.1-.2-.1-.5-.2-.7-1.4-4.4-2.1-9.1-3.6-13.3-2.2-5.7-6-10.3-9.2-15.3-12.9-20-16.4-47.4-9-70.6 1.4-4.4 3.1-8.6 4.9-12.8 1.5-3.5 2.8-7 5.2-9.7 2.5-2.8 5-4.9 7.2-8 2.3-3.4 4-6.6 8.1-7.4 1.5-.3 3-.2 4.2.7 1.6 1.1 1.9 7.4 2.1 12l.1 125.3z",
              fill: "#F9FAFA",
            },
          }),
          _c("path", {
            attrs: {
              d: "M42 146.3c.2 2.8.1 5.9-1.3 7.3-3.6 4.2-7.1-3.7-8.3-7.5-.1-.2-.1-.5-.2-.7-1.4-4.2-1.9-8.8-3.5-12.9-2.2-5.6-5.8-10-8.9-14.8C7.3 98.3 4 71.7 11.1 49.1c1.4-4.2 3.1-8.3 4.7-12.5 1.4-3.4 2.8-6.8 5.1-9.3 2.4-2.6 4.9-4.8 7-7.8 2.2-3.3 3.9-6.3 7.9-7.2 1.4-.3 3-.2 4.1.7 1.6 1.1 1.8 7.2 1.9 11.6l.2 121.7z",
              fill: "#F8F8F9",
            },
          }),
          _c("path", {
            attrs: {
              d: "M42 144.3c.2 2.7.1 5.6-1.1 7.1-3.5 4-6.7-3.6-8.1-7.3-.1-.2-.1-.5-.2-.6-1.3-4.2-1.9-8.6-3.4-12.6-2.1-5.3-5.6-9.7-8.5-14.3-12.1-19-15.3-44.5-8.3-66.5 1.4-4.2 3-8.1 4.6-12.1 1.4-3.3 2.7-6.6 4.9-9.1 2.3-2.5 4.7-4.6 6.7-7.5 2.2-3.2 3.6-6.2 7.5-6.9 1.4-.3 2.8-.2 4 .6 1.5 1.1 1.7 6.9 1.9 11.3v117.9z",
              fill: "#F7F7F7",
            },
          }),
          _c("path", {
            attrs: {
              d: "M42 142.5c.2 2.6.1 5.5-1.1 6.9-3.4 3.9-6.6-3.5-7.8-7.1-.1-.2-.1-.5-.2-.6-1.3-4.1-1.8-8.2-3.3-12.2-1.9-5.2-5.4-9.3-8.2-14C9.7 97.1 6.5 72.3 13.3 51c1.3-4.1 2.8-7.8 4.4-11.7 1.3-3.2 2.6-6.3 4.8-8.9 2.2-2.5 4.6-4.5 6.5-7.4 2.1-3 3.5-5.9 7.3-6.7 1.4-.3 2.7-.2 3.9.6 1.5 1.1 1.7 6.7 1.8 10.9v114.7z",
              fill: "#F5F6F6",
            },
          }),
          _c("path", {
            attrs: {
              d: "M42 140.7c.2 2.5.1 5.3-1.1 6.6-3.3 3.8-6.3-3.4-7.4-6.9-.1-.2-.1-.4-.2-.6-1.1-3.9-1.7-8-3.2-11.8-1.9-5-5.1-9.1-8-13.5C10.9 96.8 7.8 72.7 14.3 52c1.1-3.9 2.7-7.5 4.2-11.3 1.3-3 2.5-6.2 4.6-8.6 2.2-2.5 4.3-4.3 6.2-7.1 1.9-2.9 3.4-5.9 7.1-6.6 1.3-.3 2.6-.2 3.6.6 1.4 1 1.6 6.6 1.7 10.7l.3 111z",
              fill: "#F4F4F5",
            },
          }),
          _c("path", {
            attrs: {
              d: "M42 138.8c.1 2.5.1 5.1-1 6.4-3.2 3.6-6-3.2-7.2-6.6-.1-.2-.1-.4-.2-.6-1.1-3.8-1.7-7.7-3.1-11.4-1.8-4.9-5-8.8-7.6-13-10.7-17.2-13.7-40.4-7.5-60.3 1.1-3.8 2.6-7.4 4.1-10.9 1.1-2.9 2.4-5.9 4.4-8.2 2.1-2.4 4.2-4.2 6-6.9 1.9-2.8 3.3-5.6 6.7-6.3 1.1-.2 2.5-.2 3.5.6 1.4 1 1.6 6.3 1.7 10.3l.2 106.9z",
              fill: "#F3F3F3",
            },
          }),
          _c("path", {
            attrs: {
              d: "M42 137c.1 2.4.1 4.9-1 6.2-3.1 3.6-5.8-3.2-6.8-6.4-.1-.2-.1-.4-.1-.5-1-3.7-1.6-7.5-3-11-1.7-4.6-4.8-8.5-7.4-12.6-10.4-16.6-13.1-39-7.2-58.2 1.1-3.7 2.5-7.1 4-10.7 1.1-2.8 2.3-5.8 4.2-7.9 1.9-2.3 4.1-4.2 5.7-6.6 1.8-2.7 3.2-5.4 6.5-6.1 1.1-.2 2.4-.2 3.4.5 1.3.9 1.5 6.1 1.6 10L42 137z",
              fill: "#F1F2F2",
            },
          }),
          _c("path", {
            attrs: {
              d: "M42 135.1c.1 2.3.1 4.8-1 6-3 3.4-5.6-2.9-6.6-6.1-.1-.2-.1-.4-.1-.5-1-3.6-1.6-7.3-2.8-10.7-1.6-4.5-4.6-8.2-7.1-12.2-9.9-16-12.5-37.7-6.8-56.1 1-3.6 2.4-6.9 3.8-10.3 1-2.7 2.3-5.6 4.1-7.6 1.9-2.2 3.9-4 5.5-6.4 1.7-2.6 3.1-5.3 6.2-5.9 1.1-.2 2.3-.2 3.2.5 1.3.9 1.5 5.9 1.6 9.6v99.7z",
              fill: "#F0F0F1",
            },
          }),
          _c("path", {
            attrs: {
              d: "M42 133.2c.1 2.2.1 4.6-.9 5.9-2.7 3.2-5.4-2.8-6.3-5.9-.1-.2-.1-.4-.1-.5-1-3.4-1.5-6.9-2.7-10.3-1.6-4.3-4.4-7.9-6.7-11.7-9.5-15.3-12.1-36.2-6.6-54.2 1-3.4 2.3-6.6 3.5-9.9 1-2.5 2.2-5.4 3.9-7.5 1.8-2.2 3.6-3.9 5.2-6.2 1.7-2.5 3-5 5.9-5.7 1-.2 2.3-.2 3.1.5 1.1.8 1.4 5.7 1.5 9.2l.2 96.3z",
              fill: "#EEEFF0",
            },
          }),
          _c("path", {
            attrs: {
              d: "M42 131.3c.1 2.2.1 4.4-.9 5.6-2.6 3.2-5.1-2.7-6-5.7 0-.2-.1-.4-.1-.5-.9-3.3-1.5-6.7-2.6-9.9-1.6-4.2-4.2-7.5-6.5-11.3-9.1-14.7-11.5-34.9-6.3-52.1.9-3.2 2.2-6.3 3.4-9.5 1-2.5 2.1-5.2 3.6-7.2 1.7-2.1 3.5-3.7 5-5.9 1.6-2.5 2.7-4.9 5.7-5.5 1-.2 2.2-.2 3 .5 1.1.8 1.4 5.5 1.5 8.9l.2 92.6z",
              fill: "#EDEEEE",
            },
          }),
          _c("path", {
            attrs: {
              d: "M42 129.5c.1 2.1.1 4.2-.9 5.4-2.5 2.9-4.9-2.6-5.7-5.5 0-.2-.1-.3-.1-.5-.9-3.2-1.4-6.4-2.5-9.5-1.5-4.1-4-7.3-6.2-10.9-8.7-14.2-10.9-33.5-6-50 .9-3.2 2.2-6.1 3.3-9.1.9-2.5 1.9-4.9 3.5-6.9s3.4-3.6 4.8-5.8c1.6-2.4 2.6-4.6 5.5-5.3.9-.2 2.1-.2 2.8.5 1 .8 1.3 5.3 1.4 8.5l.1 89.1z",
              fill: "#ECECED",
            },
          }),
          _c("path", {
            attrs: {
              d: "M42 127.6c.1 2 .1 4.1-.8 5.2-2.4 2.8-4.7-2.5-5.5-5.3 0-.2-.1-.3-.1-.5-.9-2.9-1.3-6.2-2.4-9.1-1.4-3.8-3.9-6.9-5.9-10.3-8.2-13.7-10.5-32.2-5.7-48 .9-2.9 2.1-5.9 3.1-8.7.9-2.3 1.8-4.8 3.4-6.6 1.6-1.8 3.2-3.4 4.6-5.5 1.5-2.3 2.5-4.5 5.1-5 .9-.2 1.9-.2 2.7.5 1 .8 1.1 5 1.4 8.1l.1 85.2z",
              fill: "#EAEBEC",
            },
          }),
          _c("path", {
            attrs: {
              d: "M42 125.7c.1 1.9.1 3.9-.8 4.9-2.3 2.7-4.4-2.5-5.1-5 0-.2-.1-.3-.1-.5-.8-2.8-1.3-5.9-2.2-8.6-1.4-3.7-3.5-6.7-5.6-10-7.8-13-9.9-30.8-5.5-45.9.9-2.8 1.9-5.6 3-8.3.9-2.2 1.7-4.6 3.2-6.2 1.5-1.8 3.1-3.2 4.3-5.3 1.4-2.2 2.4-4.2 4.9-4.8.9-.2 1.8-.2 2.5.5.9.8 1.1 4.8 1.3 7.8l.1 81.4z",
              fill: "#E9EAEA",
            },
          }),
          _c("path", {
            attrs: {
              d: "M42 123.8c.1 1.8.1 3.8-.7 4.7-2.2 2.5-4.1-2.3-4.9-4.8 0-.2-.1-.3-.1-.5-.8-2.7-1.1-5.7-2.1-8.2-1.3-3.6-3.4-6.4-5.2-9.5-7.5-12.5-9.5-29.4-5.2-43.8.8-2.6 1.7-5.4 2.7-7.9.8-2.2 1.6-4.3 3-6 1.4-1.7 2.8-3 4.1-5 1.4-2.1 2.3-4.1 4.7-4.6.8-.2 1.7-.2 2.4.5.9.8 1 4.6 1.1 7.5l.2 77.6z",
              fill: "#E8E8E9",
            },
          }),
          _c("path", {
            attrs: {
              d: "M42 122.1c.1 1.7.1 3.6-.7 4.5-2.1 2.5-3.9-2.2-4.7-4.6 0-.2-.1-.3-.1-.4-.7-2.5-1-5.4-1.9-7.9-1.1-3.4-3.2-6.1-4.9-9-7-11.9-8.8-27.9-4.8-41.8.7-2.5 1.7-5.1 2.6-7.5.8-2 1.6-4.2 2.8-5.8 1.4-1.6 2.7-2.8 3.9-4.8 1.3-2 2.2-3.9 4.3-4.4.8-.2 1.6-.2 2.3.4.9.7 1 4.4 1.1 7.1l.1 74.2z",
              fill: "#E6E7E8",
            },
          }),
          _c("path", {
            attrs: {
              d: "M42 120.1c.1 1.6.1 3.4-.7 4.2-1.9 2.4-3.6-2.2-4.3-4.3 0-.2-.1-.2-.1-.4-.7-2.5-1-5.1-1.8-7.5-1.1-3.2-3-5.9-4.7-8.6-6.5-11.3-8.2-26.5-4.6-39.6.7-2.5 1.6-4.9 2.5-7.3.7-1.9 1.5-4 2.6-5.5 1.3-1.5 2.5-2.7 3.6-4.6 1.1-1.8 2.1-3.7 4.1-4.2.7-.2 1.5-.2 2.2.4.8.7.9 4.2 1 6.7l.2 70.7z",
              fill: "#E5E6E7",
            },
          }),
          _c("path", {
            attrs: {
              d: "M42 118.3c.1 1.5.1 3.2-.6 4.1-1.7 2.2-3.4-2-4.1-4.2 0-.2-.1-.2-.1-.4-.7-2.3-.9-4.9-1.7-7.1-1-2.9-2.8-5.6-4.3-8.1C25 91.9 23.4 77.4 27 65c.7-2.3 1.5-4.6 2.3-6.9.7-1.8 1.4-3.8 2.5-5.2 1.1-1.5 2.4-2.5 3.4-4.3 1-1.8 1.9-3.6 3.9-4 .7-.2 1.5-.2 2.1.4.8.7.9 4 .9 6.4l-.1 66.9z",
              fill: "#E3E4E5",
            },
          }),
          _c("path", {
            attrs: {
              d: "M42 116.4c.1 1.5.1 2.9-.6 3.9-1.6 2.2-3.2-1.9-3.8-3.9 0-.2-.1-.2-.1-.4-.6-2.2-.9-4.6-1.6-6.7-.9-2.8-2.6-5.3-4-7.6-5.7-10.2-7.2-23.8-4-35.6.6-2.2 1.4-4.3 2.2-6.5.6-1.7 1.3-3.6 2.3-4.9 1-1.4 2.2-2.5 3.2-4.1 1-1.7 1.7-3.3 3.5-3.8.6-.2 1.4-.2 1.8.3.7.6.8 3.8.9 6l.2 63.3z",
              fill: "#E2E3E4",
            },
          }),
        ]),
        _c("path", {
          attrs: {
            d: "M106.4 104.5l-83.8 62.4 8.7-.1c7.1-2.8 13.2-4.7 22.3-5 8-.3 17.7-.2 26-.4 3.1-.1 8.8-.2 9.6-.6 1-.6-5.8-1.3-9.5-1.9-2.1-.2-4.2-.7-6.3-1.4-1.3-.6 5.1-2.7 6.1-2.7 3-.2 6 .6 9 .6 13.9.3 27.9-.4 41.6 2.1 1.2.1 2.3.5 3.3 1.1 5 3.6-7.7 4.1-9.8 4.4-1.5.2-1.8.6-1.5 1 .5.5 2.2 1.2 3.9 1.7l.9.3 46.9-.3v-61.3l-67.4.1z",
            fill: "url(#0s2lbhkwua)",
            "fill-rule": "nonzero",
          },
        }),
        _c("path", {
          attrs: {
            fill: "#B1B1B2",
            "fill-rule": "nonzero",
            d: "M106.4 1h67.4v103.4h-67.4z",
          },
        }),
        _c("path", {
          attrs: {
            stroke: "#000",
            "stroke-width": "1.5",
            fill: "#D8D8D9",
            "fill-rule": "nonzero",
            d: "M36.8 156.2l69.7-51.7V1.1L36.2.9z",
          },
        }),
        _c("path", {
          attrs: {
            stroke: "#000",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M106 1.1h67.9v164.8",
          },
        }),
        _c("path", {
          attrs: {
            d: "M78.7 161.5l3.6.2c.5 0 1-.4 1-.9s-.4-1-.9-1l-3.6-.2c-.5 0-1 .4-1 .9-.1.5.3 1 .9 1zm-2.8-10.1c.2.5.8.7 1.3.4l3.2-1.6c.5-.1.8-.7.7-1.2-.1-.5-.7-.8-1.2-.7-.1 0-.2.1-.3.2l-3.2 1.6c-.5.3-.7.9-.5 1.3zm-4.8-7.2l2-3c.3-.5.2-1.1-.3-1.4-.5-.3-1.1-.2-1.4.3l-2 3c-.3.5-.2 1.1.3 1.4.5.3 1.1.2 1.4-.3z",
            fill: "#000",
            "fill-rule": "nonzero",
          },
        }),
        _c("path", {
          attrs: {
            stroke: "#000",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M106.4 104.5h67.4",
          },
        }),
        _c("ellipse", {
          attrs: {
            fill: "#B1B1B2",
            "fill-rule": "nonzero",
            cx: "56.4",
            cy: "178.5",
            rx: "6.2",
            ry: "1.5",
          },
        }),
        _c("ellipse", {
          attrs: {
            fill: "#B1B1B2",
            "fill-rule": "nonzero",
            cx: "26.6",
            cy: "190.1",
            rx: "6.5",
            ry: "1.6",
          },
        }),
        _c("path", {
          attrs: {
            d: "M31.2 139.7c-2.7-5.6-4.9-11.4-5.8-17.6-.3-2.4-.3-3.4 1.4-4.7 2-1.5 5-2.4 7.4-2.7.5-.1 1.1-.1 1.6.1.4.2.8.5 1.1 1 1.2 1.7 2.1 3.7 2.8 5.6 1.3 3.2 2.5 6.2 3.7 9.4 1.1 2.7 1.7 6.7 3.1 9.1 1.5 2.7 3.1 5.6 4.5 8.4 1.1 2.2 2.1 4.4 3.1 6.7.3.9.8 1.6 1.1 2.5.8 1.7-.8 2.1-1.7 3.3-3.5 4.3-3.8 3.7-7.4-.5-3.9-4.6-8.2-8.9-11.4-14-1.4-2.3-2.6-4.5-3.5-6.6z",
            stroke: "#000",
            "stroke-width": "1.5",
            fill: "#929294",
            "fill-rule": "nonzero",
          },
        }),
        _c("path", {
          attrs: {
            d: "M43.5 118.3c.2-.1.4-.1.6-.2 1.3-.3 2-1.4 3.1-2-.6 16.6-2.8 35.6-11.3 50-1.8 3-4 6-7 7.7.2-.1-2.2-.8-2.3-.9-.6-.1-1.1-.4-1.6-.7-.2-.1-2.8-1.4-2.8-1.5 1.5-4.2 2.6-8.6 4.5-12.6 4.2-9 2.7-18-4.9-24.3-6.8-5.7-6.7-16.6-6-24.7 1.6 1.1 2.5 2.4 3.8 3.8 1.3 1.6 3 2.8 4 4.5 2.2 3.7 8.6 2.7 12.1 2.3 2.5-.2 5.2-.7 7.8-1.4z",
            stroke: "#000",
            "stroke-width": "1.5",
            fill: "#929294",
            "fill-rule": "nonzero",
          },
        }),
        _c("path", {
          attrs: {
            d: "M27.6 125.9c0 .1-.2 4.9.1 9.8l.2 6.5",
            stroke: "#000",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _c("g", { attrs: { "fill-rule": "nonzero" } }, [
          _c("path", {
            attrs: {
              d: "M31 183.1l.3.6c0 1.9-4.8 1.6-6.4 1.1-4.5-1.5-5.6-8-5-11.5.3-1.8 1.8-6.4 5-4.6 3.9 2.3 3.3 6.4 3.9 9.9.1.9.4 1.8.7 2.7.3.4 1.1 1.3 1.5 1.8z",
              fill: "#000",
            },
          }),
          _c("path", {
            attrs: {
              d: "M23.7 164.7c-.6 1.1-1.3 2.3-1.9 3.4-.3.6-.6 1.2-.7 1.8l-.3 2.7c1.3-1.2 2.6-2.5 4.5-2.1 2.5.6 2.2 2.5 2.4 4.6 0 0 2.9-1.8 3.2-2.1 2.3-1.9 3.5-3 1.4-5.8-1.7-2.2-3.7-3.4-6.4-3.9-.2 0-.5-.1-.7 0-.4.1-.8.5-1.1.8-.2.2-.3.4-.4.6z",
              stroke: "#000",
              "stroke-width": "1.5",
              fill: "#FFF",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
            },
          }),
        ]),
        _c("path", {
          attrs: {
            d: "M53.2 21.2c-5.9-3.3-13.9.2-17.3 6.1-3.4 5.9-3.1 13.2-1.5 19.8.4 2.6 2.1 4.8 2.4 7.2.2 1.3-.6 2.2-1.1 3.3-.6 1.4-.8 2.6-.8 4.1 0 .2 0 .5.1.7.1.2.3.4.5.5 2.3 1.6 4.4 3.9 7.2 4.7 1 .3 2.1.3 3.1-.1 1-.5 1.7-1.5 2.6-2.1 2.4-1.8 1.2-4.2.5-6.6-.8-3.2 1-3.5 3.5-4.3 1.9-.6 3.8-.7 5.3-2.2 1.6-1.6 2.5-3.8 2.4-6.1-.1-1.7-.6-3.8.6-5 .6-.6 1.5-.9 1.7-1.6.1-.7-.2-1.4-.9-1.7-.6-.3-1.3-.4-2-.4-.6-5.5-3.1-10.7-7-14.7",
            fill: "#FFF",
            "fill-rule": "nonzero",
          },
        }),
        _c("path", {
          attrs: {
            d: "M52.8 23c3.9 4 6.3 9.2 6.9 14.7.7 0 1.3.1 2 .4.6.3 1 1 .9 1.7-.2.8-1.1 1.1-1.7 1.6-1.2 1.2-.7 3.2-.6 5 .1 3.9-2.5 7.3-6.3 8.3-1.7.4-3.7.3-4.8 1.6-.6.2.3 2.8.2 3.4",
            stroke: "#000",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _c("path", {
          attrs: {
            d: "M28.6 48.7c-2-1.5-3.6-3.7-4.4-6.1-.8-2.5-.4-5.1 1.1-7.3.5-.5.9-1.2 1.2-1.8.1-.9.1-1.8-.2-2.7-.4-3.2 1.2-6.2 4-7.7 3.2-1.6 6.9-2.7 10.2-3.8 3.1-1 6.3-2.3 9.2-3.8 1.2-.6 2.4-1.4 3.5-2.2 0 0 .8 2.9.9 3.1.1 1 .4 2.6.1 3.5-.9 2.3-3.3 4.4-5.4 5.4-2.1 1.2-4.5 2.5-4.7 4.8-.2 1.8 1.2 3.4 1.8 5.1.9 2.7.1 5.8-2.2 7.6-1.1-1.5-2.4-3.1-4.2-3.1-1.6-.1-3 1.2-3 2.8-.1 1.6 1.2 3 2.8 3 .6 0 1.2-.2 1.7-.5.3 2.1.3 4.3 0 6.4-.1.5-.2 1.1-.7 1.2-.8.2-1.5-.8-2.2.1-.2.2-.2.7-.4.9-.2.5-.6 1-.9 1.4-.1.2-.3.4-.4.6-.2.1-.5.2-.7.1-.2-.1-.3-.3-.4-.5-.4-.8-.4-1.4-1-2.1-.6-.7-1.2-1.3-1.9-1.8-1-.8-2.4-1.6-3.8-2.6z",
            fill: "#000",
            "fill-rule": "nonzero",
          },
        }),
        _c("path", {
          attrs: {
            d: "M49.8 21.2c.1 0 .2 0 .3-.1.3-.2.2-.4.1-.7-.1-.3-.2-1.7-.9-1.5-.7.2-.2 2.1.5 2.3zm-2.3 1.9c.7-.2-.4-1.4-.7-1.7-.3-.5-.6-.9-1-1.3-.5-.4-1.1-.2-.8.4.3.6 1.5 2.8 2.5 2.6zM37.3 36.5c.2 0 .4-.1.4-.4.1-.7-.1-1.3-.4-1.9-.1-.2-.4-.2-.6-.1-.2.1-.2.4-.1.6.2.4.3.9.3 1.3-.1.3 0 .5.4.5zm-3.3 2c.1 0 .2 0 .2-.1.2-.1.2-.4.1-.6-.5-.7-.9-1.5-1.2-2.3-.1-.2-.3-.3-.5-.3-.2.1-.3.3-.3.5v.1c.3.9.7 1.7 1.3 2.4.1.3.2.4.4.3z",
            fill: "#FFF",
            "fill-rule": "nonzero",
          },
        }),
        _c("path", {
          attrs: {
            d: "M55.7 32.7c-1.2-.5-2.5-.9-3.8-.7",
            stroke: "#000",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _c("path", {
          attrs: {
            d: "M59.5 43.3c-1.9.9-4.1.5-5.8-1m2.6-5.6c-.3-.4-.8-.7-1.3-.7s-1 .2-1.3.7",
            stroke: "#000",
            "stroke-width": "1.2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _c("path", {
          attrs: {
            d: "M39.1 42.5c.1-.3 1.3-.1 2.4.5",
            stroke: "#000",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _c("path", {
          attrs: {
            d: "M58.5 116.2c-.6 1.2-1.4 2.3-2.5 3.2-.4.3-.7.6-1.1.9-.8.6-1.5 1.1-2.4 1.5-.2.1-.4.2-.3.4 0 .1.1.2.1.2 1.3 1.2 3.6.2 4.9-.3l-4.9 1.8c-.3.1-.5.2-.6.4 0 .3.4.7.9.8h.1c.5.1 1 .1 1.4 0 1.6-.3 3.1-.9 4.2-1.8l-4.1 1.9c-.4.2-.9.7-.3 1 .5.3.9.1 1.3 0 1.2-.4 2.2-.8 3.5-.8.6 0-1.1 1.4-.7 1.8.4.5 2.5-.4 3-.6 1.1-.7 2-2 2.5-3.2.7-1.6.9-3.3 1.2-5m-56.3-9.1c.9 1.3 2.4 2.6 2.5 4.3v.3c-.1.3-.5.2-.8 0-.2-.2-.5-.4-.8-.3-.3.1-.4.4-.3.6.1.8.7 1.7 1 2.4.4 1.2.9 2.5.4 3.8-.5 1.3-1.2.2-2 .4-.5.1-.5.8-.9.9-.5.1-1-.4-1.6-.4-.7 0-1.3.5-1.9.2-3.4-1.7-2.9-7.9-2.8-10.9 0-.7 0-1.5.3-2.2.6-1.7 2-2.7 3.7-2 1.4.6 2.4 1.6 3.2 2.9z",
            stroke: "#000",
            "stroke-width": "1.2",
            fill: "#FFF",
            "fill-rule": "nonzero",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _c("path", {
          attrs: {
            stroke: "#000",
            "stroke-width": "1.2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M9.2 120.6l-1.3-4.1m-2.8 5c-.3-1-1.3-3.2-1.5-4.2l1.2 3.5m2.4.3l-1.3-4.6",
          },
        }),
        _c("path", {
          attrs: {
            d: "M53.8 86.8c.2.4.3.8.4 1.3.4 1.8.8 3.6 1.1 5.4 1.2 6 2.6 12.1 2.5 18.2 0 1.8-.3 2.4 1.7 3 1.4.4 2.8 1.1 4 2 1.6-1.3 1.9-3.9 2.3-5.8.4-1.8.1-3.6.2-5.4.2-2.1.4-4.3.7-6.4.3-2.4-.1-4.4-.5-6.8-.1-.6-.2-1.3-.4-1.9-.5-1.6-1.1-3.1-1.3-4.8-.6-4.6-2.2-9-4.1-13.2-.3-.6-.6-1.2-.8-1.8-.9-2-2-4.2-3.8-5.5-2.4-1.8-5.7-1.8-8.4-2.9-3.1-1.3-6-2.1-9.5-2.4-3.3-.2-6.7-.3-10.1.1-4.3.5-4.9 1.9-7.7 5-.6.7-1.4 1.3-2 2-1.9 2.1-4 5.8-5 8.4-1.6 4.1-5 7.3-7 11.2-1.2 2.4-1.9 4.8-2.5 7.4-.5 2.4-2.3 4.7-2.9 7.4-.1.4-.2.9 0 1.3.4.7 1.3.7 2.1.8.9.2 1.7.8 2.6 1 1.2.3 2.4.3 3.5.7.3.1.6.2.9.1 1-.2 1.6-3.8 1.9-4.7 1-2.6 1.9-5.2 2.7-7.8.2-1 .8-1.8 1.7-2.1 1.8-1 2.7-2.2 4.5-3.3-.5.3-.7 5-.8 5.7-.4 2-.8 4.1-1.3 6.1-.4 1.4-.6 3.9-1.5 5.2-.9 1.3-2.8 2.1-3.8 3.4-.3.4-.6.8-.6 1.3s.3.9.6 1.2c1.8 2.3 3.6 4.6 6 6.3 3.6 2.5 7.9 4.5 12.2 5.4 4.7 1 9.6.8 14.3.5 1.9-.1 2.3-.7 2.9-2.6.7-2.2.9-4.5 1.1-6.8.5-4.9.1-9.9.2-14.9s.8-10.4 2-15.3c.5.4.8.9 1 1.5.2.9.6 1.6.9 2.5z",
            fill: "#ED1D24",
            "fill-rule": "nonzero",
          },
        }),
        _c("path", {
          attrs: {
            d: "M64.5 85.6c-.2-1.2-.4-2.3-.6-3.5l-2.8 33.2c.5.2 1 .5 1.4.7l2.4-28.5c-.2-.6-.3-1.2-.4-1.9zM30.9 59.7l-5 60.5 1.5.6 5.1-61.1c-.6-.1-1.1 0-1.6 0zm-3.1.2c-.5.1-.9.1-1.3.2L21.7 118c.5.3 1 .5 1.4.8l4.9-59c-.1.1-.1.1-.2.1zM22 62.8l-2.1 25c.2-.2.5-.3.7-.5-.5.3-.7 5-.8 5.7-.2 1-.4 2.1-.6 3.1l-1.6 19.1c.4.4.9.8 1.4 1.1l4.6-55c-.6.4-1.1.9-1.6 1.5zm-5.2 27.4l2-24-.7.7c-.3.4-.6.8-1 1.2l-1.9 23.1c.2-.2.5-.4.9-.6.3-.1.5-.3.7-.4zm-2.9 16.7l-.3 3.8c.4.6.9 1.1 1.4 1.7l.6-6.7c-.6.4-1.2.8-1.7 1.2zm-.8-31.6c-.3.8-.7 1.5-1.1 2.2l-2.3 27.7h.1c.9-.2 1.4-2.8 1.7-4.1l2.3-27.5c-.2.6-.5 1.2-.7 1.7zm-6 9.5l-1.6 19.6 1.5.3 1.9-22.4c-.7.8-1.3 1.6-1.8 2.5zm28.1-25.1L30 121.6c.4.1.9.2 1.3.3h.2l5.2-62.2h-1.5zm4.3.3l-5.1 62.4c.5.1 1 .1 1.5.1L41 60.2c-.5 0-1-.1-1.5-.2zm4.4.9l-5.1 61.7h1.5l5.1-61.2c-.6-.2-1-.3-1.5-.5zm4.2 1.5l-4.9 60.1c.5 0 1-.1 1.5-.1l4.9-59.6c-.6-.1-1.1-.2-1.5-.4zm4.3 1.2l-4.9 58.3c.5-.4.8-1 1.1-2.1.7-2.2.9-4.5 1.1-6.8.5-4.9.1-9.9.2-14.9s.8-10.4 2-15.3l.3.3L53.8 64c-.4-.1-.9-.3-1.4-.4zm4.1 2.1l-2 23.9c.3 1.3.6 2.6.8 4 .1.5.2.9.3 1.4l2.3-27.5c-.4-.8-.9-1.3-1.4-1.8zm3.9 6.7s0-.1 0 0l-2.9 33.9c.2 1.8.3 3.6.3 5.4 0 1.3-.2 2 .6 2.5l3.3-39c-.5-.9-.9-1.9-1.3-2.8z",
            fill: "#FFF",
            "fill-rule": "nonzero",
          },
        }),
        _c("path", {
          attrs: {
            d: "M65.3 114.2c.3-1.1.3-2.1-.6-2.2-2.3-.4-4.7-.5-7.1-.3-.2 0 .1 4.7.4 5.1.7.8 2 .7 3 .8 1.2.1 2.2.5 3.4.8-.6-.2.5-2.4.9-4.2z",
            fill: "#FFF",
            "fill-rule": "nonzero",
          },
        }),
        _c("path", {
          attrs: {
            d: "M51 81.7c-.8 5.2-.6 13.6-.9 18.8-.3 4.9.1 9.9-.5 14.7-.2 1.6-.4 3.2-.7 4.7-.1.5-.2 1-.4 1.3-.6.9-2.9 1.1-3.9 1.2-2.5.4-5.1-.5-7.6-.5s-5 0-7.4-.6c-6.6-1.5-11.8-6-16.5-10.5-.3-.3-.7-.6-.7-1.1 0-.5.2-.9.5-1.2 1.7-2.3 4.6-5.1 5.4-7.8.8-2.9 1-4.9 1.5-8l.1-.8c.5-3.6 2.7-7 3.4-10.6.8-3.8 1.1-7.6 1-11.4",
            stroke: "#000",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _c("path", {
          attrs: {
            d: "M47.8 77.5c.6 1 1.3 2 2.2 2.8.7.7 1.5 1.3 2.1 2.2.3.5.6 1.1.8 1.6.7 1.6 1.6 3.3 1.9 5 .3 1.6.4 3.3.7 5 .2.7.3 1.5.5 2.2.6 3.2 1.1 6.5 1.3 9.8.1 1.4-.2 2.7-.3 4 0 1.2.6 2 .8 3.1.1.4 0 .8 0 1.1-.1.8-.2 1.7-.3 2.5 0 0 6.4 1.1 7 1.1.1 0 1.3-5.9 1.3-6.4.6-3.3.6-6.6.7-9.9 0-1.6.1-3.2.1-4.9 0-2.1 0-4.1-.7-6.1s-.7-4.3-1.3-6.3c-.8-2.7-1.7-5.4-2.6-8.1-.6-1.9-1.2-3.7-2.1-5.5-.9-1.8-2.1-3.4-3.3-5-.3-.4-.6-.8-1-1.1-.5-.4-1.2-.5-1.8-.7-4-.9-7.3-2.4-11.1-3.9-.8-.3-1.7-.6-2.5-.7-4.8-.7-9.7.1-14.4 1.1-1 .2-2 .5-2.8 1-.8.5-1.4 1.2-1.9 1.9C14 72.1 7.8 82.7 4 93.4c-1.1 3.2-3 6.2-2.8 9.6 0 .1 0 .2.1.3.1.1.2.1.3.2 2.2.4 6.3 2.3 8.4 1.3.1-.1.2-.3.3-.5 1.2-2.4 1.9-5.2 2.8-7.7 1.2-3.6 4.3-7.5 7.5-9.5",
            stroke: "#000",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _c("path", {
          attrs: {
            d: "M9.6 105.2c-.7 1.1-1.3 2.6-1.2 3.8 0 .5.3.7-.1 1.1-.4.4-1 .4-1.5.4-1.6.1-3.3-.3-4.7-.9-2.1-.9-1.2-5-.9-6.7 0 .2 2.4.9 2.7 1 .9.3 1.9.5 2.9.7.5.1 1 .2 1.4.2.6.1 1.1-.1 1.7 0-.2.2-.3.3-.3.4z",
            stroke: "#000",
            "stroke-width": "1.5",
            fill: "#FFF",
            "fill-rule": "nonzero",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _c("path", {
          attrs: {
            d: "M65.5 112c-4.2-.3-4-1.2-7.8-.2m-28.8 9c3.7-7.1 5-13 4.6-20.9",
            stroke: "#000",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _c("path", {
          attrs: {
            d: "M47.6 59.2c.7.2 1.5.4 2.2.6.4.1.9.3 1.1.6.2.2.2.5.3.8.1.4 3.2 2.8 3.5 2.9-6-2-12-3.8-18.3-4-1.2 0-2.2-.1-3.4.1-1.4.2-2.8.2-4.2 0 1.2-1.4 5.4-4.6 7.4-4.8 1.5-.2 5 1.6 6.5 2.3 1.5.7 3.2 1.1 4.9 1.5z",
            stroke: "#000",
            "stroke-width": "1.5",
            fill: "#ED1D24",
            "fill-rule": "nonzero",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _c("path", {
          attrs: {
            d: "M53 164.6c.7-.4 1.4-1 1.9-1.7.6-.5 1.1-1.1 1.6-1.9.1-.2.7-2.3.6-2.5.1.2.2.9.4.9.3 0 .6 0 .9-.1 1.6-.3 3.2-1.8 4.7-2.8.9-.6 2.9-2.3 3.8-1.2 3.2 4.2-4.4 11.3-6.2 13-1.5 1.4-4 4.8-6.3 3.2-.7-.5-1.2-1.3-1.7-2-.6-1-1.3-1.8-1.4-2.9 0-.2-.2-2.5-.3-2.5.2 0 .3.1.4.3.5.6 1.1.6 1.6.2z",
            fill: "#000",
            "fill-rule": "nonzero",
          },
        }),
        _c("path", {
          attrs: {
            d: "M57 158.9c0 .1.1.2.1.2 1 1.7 1 1.3.4 2.7-.5 1.3-1.8 2.5-2.8 3.2-.9.7-1.7 1.5-2.7 2-1.1-1.3-2.2-2.6-3.3-3.8l-.1-.1c-.1-.2.1-.3.2-.4 1.4-1 2.8-2 3.8-3.5.6-.8 1.9-3.8 1.3-4.8.9 1.4 2.4 3.3 3.1 4.5z",
            stroke: "#000",
            "stroke-width": "1.5",
            fill: "#FFF",
            "fill-rule": "nonzero",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }